import React, { Component } from "react";
import { Select } from "antd";
import SearchProdTile from "../../../SearchProdTile/SearchProdTile";
import "./FixedOptions.css";

class FixedOptions extends Component {
	render() {
		let query = this.props.query;
		// Ant Design select option
		const Option = Select.Option;

		// render search products
		let searchProds = this.props.searchProducts;
		let renderSearchProds = searchProds.map((prod, index) => {
			return (
				<SearchProdTile
					key={index}
					searchType={query.type === prod.name ? true : false}
					icon={prod.icon}
					name={prod.name}
					onClick={this.props.addSearchTypeToQuery}
				/>
			);
		});

		// render countries
		let renderCountryOpts = Object.keys(
			this.props.countries
		).map((c, index) => {
			return (
				<Option key={index} value={c}>
					{c}
				</Option>
			);
		});

		// render industries
//		let renderIndustryOpts = this.props.industries.sort().map((i, index) => {
//			return (
//				<Option key={index} value={i}>
//					{i}
//				</Option>
//			);
//		});
		
		if (this.props.query.type ==="targets") {
			return (
				<div>
					<section>
						<p className="panel-section-header">Searching for...</p>
						<div className="panel-section-content">{renderSearchProds}</div>
					</section>
					<section>
						<p className="panel-section-header">
							{this.props.queryTypeSingular}'s Region
						</p>
						<small>Leave this field empty to search for all regions.</small>
						<div className="panel-section-content">
							{" "}
							{query["region"] !== undefined && (
								<Select
									mode="multiple"
									style={{ width: "100%" }}
									onChange={value => this.props.buildSearchQuery("region", value)}
									defaultValue={query["region"]}
								>
									{renderCountryOpts}
								</Select>
							)}
							{query["region"] === undefined && (
								<Select
									mode="multiple"
									style={{ width: "100%" }}
									onChange={value => this.props.buildSearchQuery("region", value)}
								>
									{renderCountryOpts}
								</Select>
							)}
						</div>
					</section>
	
				</div>
			);
		
		}
		else {
			return (
				<div>
					<section>
						<p className="panel-section-header">Searching for...</p>
						<div className="panel-section-content">{renderSearchProds}</div>
					</section>
					<section>
						<p className="panel-section-header">Target's Business</p>
						{query["ownBusiness"] !== undefined ? (
							<input
								type="text"
								defaultValue={query["ownBusiness"]}
								onInput={e =>
									this.props.buildSearchQuery("ownBusiness", e.target.value)}
							/>
						) : (
							<input
								type="text"
								onInput={e =>
									this.props.buildSearchQuery("ownBusiness", e.target.value)}
							/>
						)}
					</section>
					<section>
						<p className="panel-section-header">
							{this.props.queryTypeSingular}'s Region
						</p>
						<small>Leave this field empty to search for all regions.</small>
						<div className="panel-section-content">
							{" "}
							{query["region"] !== undefined && (
								<Select
									mode="multiple"
									style={{ width: "100%" }}
									onChange={value => this.props.buildSearchQuery("region", value)}
									defaultValue={query["region"]}
								>
									{renderCountryOpts}
								</Select>
							)}
							{query["region"] === undefined && (
								<Select
									mode="multiple"
									style={{ width: "100%" }}
									onChange={value => this.props.buildSearchQuery("region", value)}
								>
									{renderCountryOpts}
								</Select>
							)}
						</div>
					</section>
	
				</div>
			);
		}
	}
}

//				<section>
//					<p classname="panel-section-header">
//						{this.props.querytypesingular}'s industry
//					</p>
//					<div classname="panel-section-content">
//						{" "}
//						{query["industry"] === undefined && (
//							<select
//								mode="multiple"
//								style={{ width: "100%" }}
//								onchange={value =>
//									this.props.buildsearchquery("industry", value)}
//							>
//								{renderindustryopts}
//							</select>
//						)}
//						{query["industry"] !== undefined && (
//							<select
//								mode="multiple"
//								style={{ width: "100%" }}
//								onchange={value =>
//									this.props.buildsearchquery("industry", value)}
//								defaultvalue={query["industry"]}
//							>
//								{renderindustryopts}
//							</select>
//						)}
//					</div>
//				</section>

export default FixedOptions;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/FixedOptions/FixedOptions.js